import * as React from 'react';
import { INTERNAL_SUPPORTED_EVENTS } from '~/common/helpers';
import { useLogout } from '~/common/hooks';

export const usePluginReauthenticateListener = () => {
  const logout = useLogout();

  React.useEffect(() => {
    // Return to the current page once the user has signed in again
    const handleReauthenticate = () => {
      logout(window.location.href);
    };

    window.addEventListener(
      INTERNAL_SUPPORTED_EVENTS.REAUTHENTICATE,
      handleReauthenticate,
    );

    return () => {
      window.removeEventListener(
        INTERNAL_SUPPORTED_EVENTS.REAUTHENTICATE,
        handleReauthenticate,
      );
    };
  }, [logout]);
};
